module.exports = __webpack_public_path__ + "img/icon_pro_base_en.d8bff286.png";